import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { DatePicker, Switch } from "antd";
import "moment/locale/es-us";
import moment from "moment";

const { RangePicker } = DatePicker;

export class Copyright extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createDate: moment().format("YYYY-MM-DD"),
      dueDate: moment().format("YYYY-MM-DD"),
      isUndefined: true
    };
  }

  componentDidMount() {
    const { fillCreateDate, fillDueDate } = this.props;

    if (fillCreateDate) {
      this.setState({
        createDate: fillCreateDate,
        dueDate: fillDueDate,
        isUndefined: !fillDueDate
      });
    }
  }

  handleOnChangeRangePicker = (date, dateString) => {
    const { isUndefined } = this.state;

    this.setState(
      {
        createDate: dateString[0],
        dueDate: isUndefined ? null : dateString[1]
      },
      () => {
        this.props.handleCopyright({
          copyright: {
            createDate: dateString[0],
            dueDate: isUndefined ? null : dateString[1]
          }
        });
      }
    );
  };

  handleOnChangeCreateDate = (date, dateString) => {
    const { dueDate, isUndefined } = this.state;
    this.props.handleCopyright({
      copyright: {
        createDate: dateString,
        dueDate: isUndefined ? null : dueDate
      }
    });
    this.setState({
      createDate: dateString
    });
  };

  handleOnChangeDueDate = (date, dateString) => {
    const { createDate, isUndefined } = this.state;
    this.props.handleCopyright({
      copyright: {
        createDate: createDate,
        dueDate: isUndefined ? null : dateString
      }
    });
    this.setState({
      dueDate: isUndefined ? null : dateString
    });
  };

  handleIsUndefined = isUndefined => {
    const { createDate, dueDate } = this.state;
    this.setState(
      {
        isUndefined
      },
      () => {
        this.props.handleCopyright({
          copyright: {
            createDate,
            dueDate: isUndefined ? null : dueDate
          }
        });
      }
    );
  };

  render() {
    const { intl, width } = this.props;
    const { createDate, dueDate, isUndefined } = this.state;
    const isMobile = width ? (width <= 578 ? true : false) : false;

    return (
      <div>
        <span>{intl.formatMessage({ id: "copyright_image_use_rights" })}</span>

        <div style={{ display: "inline", marginLeft: 10 }}>
          <Switch
            onChange={this.handleIsUndefined}
            checkedChildren={intl.formatMessage({ id: "undefined" })}
            unCheckedChildren={intl.formatMessage({ id: "set_duration" })}
            checked={isUndefined}
          />
        </div>

        {!isUndefined && isMobile && (
          <div>
            <span>{intl.formatMessage({ id: "copyright_creation_date" })}</span>
            <div>
              <DatePicker
                placeholder={intl.formatMessage({
                  id: "copyright_date_picker"
                })}
                onChange={this.handleOnChangeCreateDate}
                defaultValue={moment(createDate, "YYYY-MM-DD")}
              />
            </div>
            <span>{intl.formatMessage({ id: "copyright_due_date" })}</span>
            <div>
              <DatePicker
                placeholder={intl.formatMessage({
                  id: "copyright_date_picker"
                })}
                onChange={this.handleOnChangeDueDate}
                defaultValue={dueDate ? moment(dueDate, "YYYY-MM-DD") : null}
              />
            </div>
          </div>
        )}
        {!isUndefined && !isMobile && (
          <div>
            <RangePicker
              placeholder={intl.formatMessage({ id: "copyright_date_picker" })}
              onChange={this.handleOnChangeRangePicker}
              defaultValue={[
                moment(createDate, "YYYY-MM-DD"),
                dueDate ? moment(dueDate, "YYYY-MM-DD") : null
              ]}
            />
          </div>
        )}
        <br />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  width: state.app.width
});

const mapDispatchToProps = {};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Copyright))
);
